module.exports = __webpack_public_path__ + "img/145-0e42f3.png";